"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger(options) {
        this.options = options;
        this.handler = window.console;
    }
    ConsoleLogger.prototype.increment = function (name, delta) {
        this.handler.log(['trackEvent', this.options.prefix, '', name, delta]);
    };
    ConsoleLogger.prototype.gauge = function (name, value) {
        this.handler.log(['trackEvent', this.options.prefix, '', name, value]);
    };
    ConsoleLogger.prototype.timing = function (name, time) {
        this.handler.log([
            'trackEvent',
            this.options.prefix,
            '',
            name,
            new Date().getTime() - time.getTime(),
        ]);
    };
    return ConsoleLogger;
}());
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=ConsoleLogger.js.map